import { CategoryAndTag, TimePeriod } from "api/generated/model";
import { FilterType } from "components/filters/filterType";

/**
 * The applied Control Health filters. Deliberately kept independent of any
 * widget or table so it can later be translated into fetch parameters.
 */
export interface ControlHealthFilters {
    showInactivePrograms: boolean;
    showArchivedActivities: boolean;
    dateRangePreset: TimePeriod;
    tags: CategoryAndTag[];
    controlPrograms: number[];
    entities: number[];
}

/** The filter categories a user can add a row for. The date range is always shown. */
export type ControlHealthFilterType = FilterType;

export const DEFAULT_CONTROL_HEALTH_FILTERS: ControlHealthFilters = {
    showInactivePrograms: false,
    showArchivedActivities: false,
    dateRangePreset: { type: "CurrentMonth" },
    tags: [],
    controlPrograms: [],
    entities: [],
};
